import React from "react";
import "./Card.css";

// Import the new component (optional, as it's used in LandingPage, but good to know)
// import TypewriterText from "./TypewriterText";

/**
 * Reusable Card component.
 * @param {string} title - The main heading of the card.
 * @param {React.ReactNode} children - The content (paragraphs, lists, etc.) inside the card.
 * @param {string} className - Optional class name for custom styling (e.g., card-module).
 */
function Card({ title, children, className = "" }) {
  // Use className prop to allow external files (like LandingPage) to pass in custom classes
  return (
    // 'card-container' is the stable class name for base styling
    <div className={`card-container ${className}`}>
      {/* Conditionally render the title if it exists */}
      {title && <h2>{title}</h2>}

      {/* Render the children content */}
      <div className="card-content">
        {children}{" "}
        {/* This is where the TypewriterText component will be placed */}
      </div>
    </div>
  );
}

export default Card;
